import axios from '@/plugins/axios';
import { getData, postData } from '@/utils/apiTools';
import { ConsentStatusType } from '@/models/ConsentStatusType';

interface ConsentStatusResponse {
  status: 'ACCEPTED' | 'REQUESTED' | 'DENIED';
  timestamp: string;
  gracePeriod: number;
  object: {
    type: 'LEGAL' | 'DATA';
    version: string;
    timestamp: string;
  };
}

const getConsentStatus = async (type: ConsentStatusType): Promise<ConsentStatusResponse> => (getData(`/v1/legalagreements/consentStatus?type=${type}`));

const getLatestConsentDocumentVersion = async (type: ConsentStatusType): Promise<string> => {
  const { version } = await getData(`/v1/legalagreements/documents?type=${type}&version=latest`);
  return version;
};

const storeConsentStatusEntry = async (type: ConsentStatusType, version: string, status: 'ACCEPTED' | 'REQUESTED') => {
  await postData('/v1/legalagreements/consentStatus', {
    type,
    version,
    status,
  });
};

const getDocumentPdf = async (type: ConsentStatusType, version = 'latest') => {
  const { data } = await axios.get(`/v1/legalagreements/documents/${type}/${version}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf',
    },
  });
  return data;
};

export {
  getDocumentPdf,
  getConsentStatus,
  getLatestConsentDocumentVersion,
  storeConsentStatusEntry,
};
